import { useMemo, useState, useContext } from 'react';
import { useQueries } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ToastContext } from 'contexts';
import { VENDORS_ME_CONTRACTS } from 'constants/apis';
import { useApp } from 'providers/AppProvider';
import axios from 'helpers/axios';

export const useDashboardContracts = () => {
  const { apiRegions } = useApp();
  const { t } = useTranslation();
  const { triggerToast } = useContext(ToastContext);
  const [hasShownToast, setHasShownToast] = useState(false);

  const contractResults = useQueries({
    queries: (apiRegions ?? []).map(region => ({
      queryKey: ['vendors', 'me', 'contracts', region],
      queryFn: () =>
        axios.get(VENDORS_ME_CONTRACTS, {
          params: { region },
        }),
      onError: () => {
        // Only show a single toast even if all region queries fail.
        // The component will have to remount anyways to refetch the query.
        if (!hasShownToast) {
          triggerToast({ message: t('generic_error') });
          setHasShownToast(true);
        }
      },
    })),
  });

  const contracts = useMemo(
    () =>
      contractResults.reduce((contracts, result) => {
        const { data: { data } = {}, isError, isLoading } = result;

        if (isError || isLoading || !data?.length) {
          return contracts;
        }

        return contracts.concat(data);
      }, []),
    [contractResults]
  );

  return contracts;
};
